var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStartLearning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.94,41.59h-4l-.65,1.64h-2.49l4-9.28h2.49l3.89,9.28h-2.58Zm-.71-1.85L154,36.43l-1.29,3.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,402.31a10.21,10.21,0,0,1-8-3.71l2.76-4.1a7.35,7.35,0,0,0,4.82,2.59c1.48,0,2.4-.91,2.4-2.65V384H42.12v-4.95H56v15.52C56,399.49,53,402.31,48,402.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1,314.38l-4.18-6.23-2.07,2.3v3.93h-4.2v-16.1h4.2V305l6-6.75h4.87l-6,6.66,6.33,9.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.43,306.66,56,316.72V306.66h4.05v16.71H56.25l-7.58-10v10H44.59V306.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.25,272.13l2.46,5.42,2.46-5.42h2.65v9.29h-2.14l0-5.89-2.15,5h-1.59l-2.16-5v5.89H396.6v-9.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.24,32l2.46,5.42L329.16,32h2.65v9.28h-2.14l0-5.88-2.16,5h-1.58l-2.16-5v5.88h-2.16V32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.22,315.14V328.4h7.23v3.8H468.77V315.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.23,34v7.22h3.94v2.06h-6.36V34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.24,77.25v7.22h3.93v2.07h-6.36V77.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.05,165.36c-2.08,0-3.45.76-3.45,2.27,0,5.48,17.45,2.36,17.45,14.28,0,6.76-6,10.21-13.34,10.21a24.91,24.91,0,0,1-15.27-5.29l3.36-6.76c3.4,2.93,8.56,5,12,5,2.55,0,4.16-1,4.16-2.7,0-5.62-17.45-2.22-17.45-13.95,0-6.19,5.25-10.12,13.24-10.12A25.45,25.45,0,0,1,472,162.05l-3.26,6.86C465.24,166.92,460.79,165.36,458.05,165.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,328.24c-2.08,0-3.45.76-3.45,2.27,0,5.49,17.45,2.37,17.45,14.28,0,6.76-6,10.22-13.33,10.22a24.92,24.92,0,0,1-15.28-5.3l3.36-6.76c3.4,2.93,8.56,5,12,5,2.55,0,4.16-.95,4.16-2.7,0-5.62-17.45-2.22-17.45-13.95,0-6.19,5.25-10.11,13.24-10.11A25.44,25.44,0,0,1,373,324.93l-3.26,6.86C366.21,329.8,361.77,328.24,359,328.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.85,125.89c0,8.44-6.18,14.18-15.35,14.18H235.58V111.75h12.2C256.75,111.75,262.85,117.49,262.85,125.89Zm-7.55.08c0-4.89-3.19-8.2-7.68-8.2H243v16.32h5C252.27,134.09,255.3,130.82,255.3,126Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.36,224.81,406.85,220H403.5v4.77H399V207.58h7.74c4.57,0,7.18,2.21,7.18,6a5.82,5.82,0,0,1-3.07,5.55l3.58,5.63Zm-5.86-8.36h3.27c1.82,0,2.88-.93,2.88-2.68s-1.06-2.6-2.88-2.6H403.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.46,315.93v5.8h-8.07v21.12h-7V321.73h-8v-5.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.72,260.63a4.87,4.87,0,0,1-3.8,4.76,5.44,5.44,0,0,1,4.52,5.56c0,3.76-3.3,6.11-8.47,6.11H343.11v-22h10.45C358.55,255.07,361.72,257.24,361.72,260.63Zm-5.9,1c0-1.32-1-2.1-2.57-2.07h-4.4v4.27h4.4C354.85,263.83,355.82,263,355.82,261.63Zm.69,8.6c0-1.38-1.26-2.26-3.26-2.23h-4.4v4.61h4.4C355.25,272.61,356.51,271.73,356.51,270.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.38,57.38a4.88,4.88,0,0,1-3.8,4.77,5.44,5.44,0,0,1,4.52,5.55c0,3.77-3.29,6.12-8.47,6.12H438.77v-22h10.45C454.21,51.83,457.38,54,457.38,57.38Zm-5.9,1c0-1.32-1-2.11-2.57-2.07h-4.39v4.26h4.39C450.51,60.58,451.48,59.77,451.48,58.39Zm.69,8.59c0-1.38-1.25-2.26-3.26-2.22h-4.39v4.61h4.39C450.92,69.37,452.17,68.49,452.17,67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.91,267.74a6.22,6.22,0,0,0,0,12.42,8.15,8.15,0,0,0,5.46-2.57l3.36,3.6a13.14,13.14,0,0,1-9.13,4.08c-6.62,0-11.55-4.83-11.55-11.29s5.06-11.11,11.77-11.11a12.64,12.64,0,0,1,8.88,3.77l-3.33,4A7.49,7.49,0,0,0,198.91,267.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.8,383.05a6.22,6.22,0,0,0,0,12.42,8.15,8.15,0,0,0,5.46-2.57l3.36,3.61a13.16,13.16,0,0,1-9.13,4.08,11.14,11.14,0,0,1-11.55-11.3c0-6.33,5.05-11.1,11.77-11.1a12.64,12.64,0,0,1,8.88,3.76l-3.33,4A7.46,7.46,0,0,0,444.8,383.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.69,88.29H366.36L364,94.15h-8.89L369.38,61h8.89l13.91,33.15H383Zm-2.56-6.62-4.54-11.83L369,81.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.07,73.06v7h-5.7V73.22l-8.05-15H297l5.17,9.39,5.06-9.39H313Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.73,109c2.83,0,4.79-1.92,4.79-5.1V89.7h6.39v14.21c0,6.46-4.33,10.55-11.21,10.55s-11.35-4.09-11.35-10.55V89.7h6.39v14.21A4.77,4.77,0,0,0,189.73,109Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,324.77l0,5.56h-13v5.95h12v5.56h-12v9.64h-7V324.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.64,238.87V247h8v-8.13h5.2v19.94h-5.2v-7.66h-8v7.66H22.43V238.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.46,132v19.83h-5.17V132Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.38,40.75c0,6.92-5.46,12.11-12.78,12.11s-12.79-5.19-12.79-12.11,5.47-12,12.79-12S243.38,33.9,243.38,40.75Zm-19.23,0a6.68,6.68,0,0,0,6.52,6.82A6.54,6.54,0,0,0,237,40.78,6.48,6.48,0,0,0,230.67,34,6.59,6.59,0,0,0,224.15,40.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.26,244.87l5.91,17.1,5.93-17.1h6.35l-9.25,23.65h-6.41l-9.17-23.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.73,127l3.27,9.45,3.28-9.45h3.5l-5.11,13.06h-3.54L328.07,127Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2,75.14c0,4.13-2.59,6.54-7.07,6.54H33v4.86H28.41V69h7.72C40.61,69,43.2,71.23,43.2,75.14Zm-4.36.15c0-1.73-1.08-2.66-2.94-2.66H33V78h2.9C37.76,78,38.84,77.07,38.84,75.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.08,106.28l3.64,8,3.63-8h3.91V120H467.1l0-8.68-3.19,7.32h-2.35l-3.18-7.32V120h-3.19v-13.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.34,158.69v6.91H54.84v6.19H70.63v6.86l-15.79,0v6.25h18v6.9H46.19V158.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,46.9v5.67L98.47,73.09h17.78v7H86.88V74.42l17.5-20.57H87.5v-7Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M477.31,449.4c0,.15-102.27.26-228.39.26S20.5,449.55,20.5,449.4s102.25-.26,228.42-.26S477.31,449.26,477.31,449.4Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Dictionary--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.49,78.56a1.94,1.94,0,0,0-2.43-1.29L174.3,80,54.16,111.87,96.94,278.6l14.89,7.83,122.28-34a3.68,3.68,0,0,0,2.54-4.61Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.9 71.95 183.87 78.97 235.12 249.73 111.63 284.99 97.6 277.37 171.9 71.95",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.33,242.63l-121.39,36L47.86,113a4.17,4.17,0,0,1,2.74-5.15l120.09-37.7a2.31,2.31,0,0,1,2.91,1.57l47.45,166A4,4,0,0,1,218.33,242.63Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.47,271.59c-.13,0-11.43-37-25.22-82.82s-24.87-82.94-24.73-83,11.43,37,25.23,82.83S112.61,271.55,112.47,271.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.19,275.87c-.14.05-11.43-37-25.22-82.82s-24.87-82.93-24.73-83,11.43,37,25.22,82.83S108.33,275.83,108.19,275.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.88,151c.81,2.56-.52,4.9-3.31,5.77L96,157.92l-2.71-8.6,3.7-1.17C99.67,147.29,102.08,148.45,102.88,151Zm-2.29.75A2.41,2.41,0,0,0,97.48,150l-1.41.44,1.56,5,1.52-.48A2.34,2.34,0,0,0,100.59,151.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.89,145.64l2.71,8.6-2.24.71-2.71-8.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.23,145.67a2.55,2.55,0,0,0,1.53,4.86,3.39,3.39,0,0,0,1.82-1.68l1.75,1a5.4,5.4,0,0,1-3.06,2.72,4.6,4.6,0,1,1-2.68-8.79,5.18,5.18,0,0,1,3.94.38l-.81,2A3.05,3.05,0,0,0,111.23,145.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.68,140.35l.58,1.85-2.57.82,2.13,6.74-2.25.71-2.13-6.75-2.55.81-.58-1.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.84,139.36l2.71,8.6-2.25.71-2.71-8.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.61,140.37a4.89,4.89,0,1,1-6-2.89A4.64,4.64,0,0,1,136.61,140.37Zm-7,2.21a2.55,2.55,0,0,0,3.15,1.74,2.6,2.6,0,0,0-1.56-4.94A2.52,2.52,0,0,0,129.62,142.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.35,135.1l5.53,4-1.63-5.18,2.09-.66,2.71,8.6-2,.62-5.52-3.92,1.62,5.15-2.09.66-2.72-8.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,138l-3.71,1.17-.13,1.72-2.3.72,1-9.76,2.31-.73,6.31,7.47-2.39.75Zm-1.2-1.5-2.15-2.7-.23,3.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.39,136.66l-2-2h0l-1.62.51.75,2.38-2.25.71-2.71-8.6,3.86-1.22c2.29-.72,3.93,0,4.54,1.89a3.06,3.06,0,0,1-.66,3.26l2.68,2.24Zm-4.24-3.25,1.63-.51a1.32,1.32,0,0,0,1-1.79,1.3,1.3,0,0,0-1.85-.85l-1.63.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.68,131.34l.87,2.75-2.25.71-.84-2.69-5-4.91,2.24-.71,3.2,3,.83-4.32,2.24-.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.47,177.42l-9.77,3.08-.32,4.49-6.07,1.92,2.59-25.67,6.06-1.91L140.57,179l-6.29,2Zm-3.17-4-5.63-7.08-.62,9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,164l1.16,3.67-8.55,2.7-1.16-3.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.07,146.06l1.22,3.87-7.52,17.75,12.13-3.82,1.49,4.74-20,6.31-1.21-3.83,7.51-17.79-11.51,3.63-1.49-4.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.68,247l-.28.11-.85.29-3.26,1-12,3.76-39.73,12.2-39.78,12.06L116.69,280l-3.29,1-.86.24a1.11,1.11,0,0,1-.3.06,1.23,1.23,0,0,1,.28-.11l.85-.29,3.26-1,12-3.76,39.74-12.21,39.77-12.05,12.07-3.6,3.29-1,.86-.23A1.18,1.18,0,0,1,224.68,247Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.61,264.71l-18.41,5.65a87.63,87.63,0,0,1,9.12,25.35,25.66,25.66,0,0,0,4.13-13.54A95.23,95.23,0,0,0,161.6,292.6,70,70,0,0,0,156.61,264.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.43,244.72s-.09.05-.28.12l-.84.28-3.26,1-12,3.75-39.73,12.21-39.77,12.06-12.07,3.6-3.29.95-.86.23-.3.07a1.2,1.2,0,0,1,.28-.12l.84-.28,3.27-1.05,12-3.75,39.73-12.21,39.78-12.06L218,246l3.29-.95.86-.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.16,240a2.69,2.69,0,0,1-.15-.42l-.37-1.24-1.37-4.76c-1.18-4.16-2.88-10.14-5-17.52-4.2-14.8-10.05-35.24-16.64-57.77S190,115.41,185.52,100.68c-2.21-7.35-4-13.3-5.26-17.45-.6-2-1.08-3.64-1.41-4.75-.15-.52-.27-.93-.35-1.23a2.79,2.79,0,0,1-.11-.43,3.46,3.46,0,0,1,.16.41c.09.3.23.7.4,1.22.35,1.11.86,2.69,1.51,4.72,1.28,4.13,3.13,10.07,5.42,17.4,4.53,14.7,10.68,35.05,17.28,57.59s12.38,43,16.49,57.81c2,7.4,3.68,13.39,4.82,17.57l1.28,4.79c.13.53.24.94.31,1.25S226.16,240,226.16,240Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32,108.79s0-.12-.12-.34l-.33-1q-.44-1.36-1.26-3.9c-1.08-3.4-2.65-8.35-4.64-14.6l.19.1L75.9,117.61h0l.17-.33c2.13,6.82,4.21,13.49,6.2,19.9l-.32-.17L147,116.84l19.25-5.92,5.21-1.59,1.36-.41.47-.13-.43.16-1.32.42L166.44,111l-19.16,6L82.1,137.51l-.25.07-.08-.24c-2-6.41-4.08-13.08-6.2-19.89l-.08-.25.25-.08h0l91.33-28.36.14-.05,0,.14c1.93,6.31,3.45,11.3,4.51,14.74.5,1.68.9,3,1.17,3.88.13.43.22.75.29,1A1.93,1.93,0,0,1,173.32,108.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 399.93,
    cy: 132.16,
    r: 41.54,
    transform: "translate(-20.3 160.68) rotate(-22.17)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,173.23c-.05,0,0-.45-.27-1.21a5.49,5.49,0,0,0-1.92-2.7,5.16,5.16,0,0,0-2.07-1,4.51,4.51,0,0,0-2.57.23,5,5,0,0,0-.29,9.33,4.61,4.61,0,0,0,2.55.38,5.26,5.26,0,0,0,2.13-.84,5.46,5.46,0,0,0,2.08-2.57c.28-.75.3-1.21.34-1.2a1.37,1.37,0,0,1,0,.33,1.55,1.55,0,0,1-.06.39,2.46,2.46,0,0,1-.14.53,5.55,5.55,0,0,1-4.3,3.67,4.77,4.77,0,0,1-2.75-.37,5.55,5.55,0,0,1-2.36-2,5.35,5.35,0,0,1-1-3.14,5.29,5.29,0,0,1,1.18-3.08,5.66,5.66,0,0,1,2.47-1.81,4.83,4.83,0,0,1,2.77-.2A5.38,5.38,0,0,1,364,169.1a5.53,5.53,0,0,1,1.9,2.87,4.51,4.51,0,0,1,.1.54,1.48,1.48,0,0,1,0,.4A1.57,1.57,0,0,1,366,173.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.92,173.47l.68.06,2,.22,1.45.16c.54,0,1.13,0,1.77,0l2.06,0a6.3,6.3,0,0,0,1.14-.05l1.21-.1a39.92,39.92,0,0,0,11.73-2.7,41.72,41.72,0,0,0,13.44-8.47l1.63-1.56c.51-.55,1-1.15,1.51-1.73l.77-.88a9.66,9.66,0,0,0,.73-.93l1.39-2c.23-.33.47-.65.7-1l.61-1.07c.4-.72.82-1.44,1.23-2.17s.7-1.54,1.06-2.31c.18-.39.35-.79.53-1.18.08-.2.18-.39.25-.59l.21-.62a38.45,38.45,0,0,0,1.48-5.1c.18-.88.42-1.75.56-2.66s.21-1.82.32-2.74c.05-.46.13-.92.15-1.39s0-.93,0-1.4c0-.94.05-1.89,0-2.84a43.52,43.52,0,0,0-.68-5.75l-.27-1.45c0-.24-.08-.48-.14-.73l-.2-.71c-.28-1-.55-1.91-.83-2.87s-.73-1.87-1.09-2.82c-.2-.46-.36-1-.59-1.4l-.7-1.36a45.88,45.88,0,0,0-3.17-5.33c-.64-.83-1.29-1.65-1.94-2.48l-.49-.63-.55-.57-1.1-1.16-1.1-1.16-1.21-1L426.27,100l-.61-.53c-.21-.16-.44-.31-.66-.47l-2.66-1.89-2.85-1.63a41.24,41.24,0,0,0-25.91-4.4l-3.23.6-3.14.9-.78.23-.75.3-1.5.6-1.49.59-1.43.73-1.41.73-.71.37-.66.42-2.66,1.7a47.05,47.05,0,0,0-4.75,4L370,103.29c-.37.35-.68.76-1,1.14-.65.77-1.34,1.51-2,2.3l-1.73,2.43-.43.61c-.13.21-.25.42-.37.64-.25.42-.49.85-.73,1.27a43.89,43.89,0,0,0-2.54,5.21c-.34.89-.61,1.8-.92,2.69-.14.44-.29.89-.44,1.33s-.21.91-.32,1.36c-.2.91-.4,1.8-.6,2.7s-.23,1.8-.35,2.69a39.57,39.57,0,0,0-.28,5.3v.65c0,.22,0,.43.05.65,0,.43.07.86.1,1.28.09.85.11,1.7.24,2.53s.3,1.65.45,2.46c.08.4.15.81.22,1.21l.33,1.17c.23.78.45,1.55.67,2.31a7.31,7.31,0,0,0,.39,1.11c.14.37.28.73.43,1.09.29.72.55,1.44.86,2.13s.68,1.35,1,2a41.63,41.63,0,0,0,9.9,12.43c.44.38.87.77,1.31,1.13l1.36,1,1.31.94c.22.15.43.31.65.44l.66.38,2.51,1.45c.81.43,1.63.75,2.38,1.11l1.1.49a7.07,7.07,0,0,0,1.06.42l1.95.66c.61.2,1.17.41,1.68.55l1.43.33,1.94.45.66.16s-.23,0-.67-.12l-1.94-.42-1.44-.31c-.52-.13-1.08-.34-1.69-.53l-2-.64a6.67,6.67,0,0,1-1.06-.42l-1.11-.49c-.76-.35-1.58-.66-2.4-1.09L378.11,168l-.67-.38c-.22-.13-.42-.29-.64-.44l-1.32-.93-1.38-1-1.32-1.14a41.54,41.54,0,0,1-10-12.47c-.35-.66-.69-1.33-1-2s-.58-1.42-.87-2.14c-.14-.37-.29-.73-.44-1.1a7.06,7.06,0,0,1-.39-1.12c-.22-.77-.45-1.54-.67-2.32-.12-.39-.24-.78-.34-1.18s-.15-.81-.23-1.22c-.15-.82-.3-1.64-.46-2.47s-.16-1.7-.24-2.55c0-.43-.08-.86-.11-1.3,0-.21-.05-.43-.05-.65V133a38.6,38.6,0,0,1,.27-5.34c.12-.89.18-1.81.35-2.71l.6-2.72c.11-.46.18-.92.32-1.37l.45-1.35c.3-.89.57-1.81.92-2.71a43,43,0,0,1,2.55-5.25l.73-1.29c.13-.22.24-.44.38-.65L365,109q.87-1.21,1.74-2.46c.62-.79,1.32-1.54,2-2.32.34-.38.65-.79,1-1.14l1.12-1.07a47.91,47.91,0,0,1,4.79-4l2.68-1.71.67-.43.71-.37,1.43-.74,1.44-.73,1.51-.61,1.51-.6.76-.3.78-.23,3.17-.92,3.26-.6a41.59,41.59,0,0,1,26.15,4.44l2.88,1.65,2.68,1.9c.22.16.45.31.67.48l.61.54,1.23,1.06,1.23,1.07,1.11,1.17,1.11,1.16c.18.2.37.39.54.59l.5.63,2,2.5a47.53,47.53,0,0,1,3.19,5.38l.7,1.37c.24.46.4,1,.59,1.42.37,1,.78,1.89,1.1,2.85l.84,2.89.2.72c.06.24.1.49.15.73.09.49.18,1,.26,1.46a42.81,42.81,0,0,1,.68,5.8c0,1,0,1.92,0,2.87,0,.47,0,.94,0,1.41s-.1.94-.15,1.4l-.33,2.77c-.14.91-.38,1.79-.56,2.68a39,39,0,0,1-1.51,5.13l-.21.62c-.07.2-.17.4-.26.6l-.53,1.19c-.36.78-.67,1.57-1.07,2.32L436,153.68l-.62,1.08c-.23.34-.47.67-.7,1l-1.41,2a7.37,7.37,0,0,1-.74.93l-.77.89c-.52.58-1,1.18-1.53,1.74l-1.64,1.56A41.64,41.64,0,0,1,415,171.32,39.76,39.76,0,0,1,403.22,174l-1.21.09a6.27,6.27,0,0,1-1.14,0l-2.07,0c-.64,0-1.24,0-1.77-.05l-1.46-.18-2-.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,123h5.86a5,5,0,0,1,5.11-5,4.75,4.75,0,0,1,4.59,3,5.24,5.24,0,0,1-.42,4.74c-1,1.64-3.17,3.13-7.12,2.43v13.21h5.79v-7.73a11.32,11.32,0,0,0,8.13-11.06c0-8.57-7.68-10.55-11-10.55C398.43,112.1,389.87,112.7,390,123Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.99,
    y: 144.16,
    width: 5.88,
    height: 5.49,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.19,143.18c-5.85-4.47-6.54-13.72-2.61-19.94s11.4-9.55,18.74-10.08a33.88,33.88,0,0,1,28.22,12.19c3.63,4.47,6.39,10.12,11.64,12.48,4.61,2.08,10,1,14.95,2.13,6.63,1.46,11.95,6.73,14.88,12.85s3.74,13,3.94,19.81c.18,6.23.07,13,3.95,17.9s10.27,6.26,15.18,9.83c9.23,6.73,11.11,21.54,3.85,30.35-2.31,2.82-5.5,5.3-6.06,8.9-.51,3.28,1.37,6.42,2.09,9.66,1.86,8.36-5.64,17.43-14.2,17.17-4.32-.14-8.78-2.22-12.8-.64s-5.82,6.06-8.58,9.35A18.47,18.47,0,0,1,302.43,279c-3-1.83-5.78-4.65-9.32-4.72s-6.55,2.67-10.06,3c-4.59.47-8.58-3.23-10.94-7.2s-3.84-8.54-7-11.9c-4.14-4.4-10.38-5.94-15.9-8.41a46.76,46.76,0,0,1-20.55-67.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.53,229.88a12.73,12.73,0,0,1,5.32-2.86l-.38-.05a6.68,6.68,0,0,1,1.09-.09,5,5,0,0,1,3.88.83h0a9.37,9.37,0,0,1,4.7,4.88,11,11,0,0,1-2.3,11.21c-2.35,2.59-6.15,4.08-9.46,3-3-1-5.1-4.05-5.71-7.21A10.51,10.51,0,0,1,310.53,229.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.18,187.75c-.06-17.59-10.38-39.77-27.95-39l-55.32,10.53a10.28,10.28,0,0,0-9.81,9.87l-7.63,148.29,62.61-.33c.76-10.61,3.56-40.48,3.56-40.38s24.37-2.32,30.74-31.24C319.56,231.13,320.24,207.28,320.18,187.75Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.05,211.69a3.74,3.74,0,0,1-3.83,3.56,3.58,3.58,0,0,1-3.66-3.6,3.75,3.75,0,0,1,3.83-3.57A3.59,3.59,0,0,1,307.05,211.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.31,197.84c-.49.46-3.2-1.81-7.24-2s-7.1,1.61-7.51,1.09c-.2-.23.33-1.08,1.67-1.94a10.28,10.28,0,0,1,6-1.48A9.82,9.82,0,0,1,313,195.7C314.19,196.73,314.55,197.64,314.31,197.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.8,209.2a3.74,3.74,0,0,1-3.83,3.56,3.58,3.58,0,0,1-3.66-3.61,3.75,3.75,0,0,1,3.83-3.56A3.59,3.59,0,0,1,270.8,209.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.66,196.23c-.5.46-3.21-1.81-7.24-2s-7.1,1.61-7.51,1.09c-.2-.23.32-1.08,1.67-1.94a10.24,10.24,0,0,1,6-1.48,9.88,9.88,0,0,1,5.73,2.23C274.53,195.12,274.9,196,274.66,196.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.5,227c0-.23,2.52-.52,6.61-.79,1,0,2-.2,2.24-.89s-.08-1.86-.5-3.09l-2.58-8c-3.56-11.41-6.07-20.77-5.61-20.91s3.72,9,7.28,20.4c.85,2.82,1.67,5.5,2.44,8.06.32,1.19.91,2.56.3,4.07a2.58,2.58,0,0,1-1.78,1.4,6.72,6.72,0,0,1-1.77.14C290,227.35,287.5,227.22,287.5,227Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.89,276.37s-18,.16-36.72-12.7c0,0,6.52,22.41,35.91,21.42Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.33,236.53a9.93,9.93,0,0,0-7.9-4.81,6.46,6.46,0,0,0-5.48,2.56,6.26,6.26,0,0,0-.29,6.52,6.18,6.18,0,0,0,6.4,2.74c2.31-.41,4.28-1.86,6.15-3.31a4.68,4.68,0,0,0,1.37-1.43,2.1,2.1,0,0,0,0-2.06",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.47,229.07c.66,0,.41,4.37,4,7.7s8.24,3.12,8.24,3.74c0,.28-1.09.79-3.06.72a11,11,0,0,1-6.9-2.87,9.49,9.49,0,0,1-3-6.44C274.62,230.08,275.18,229,275.47,229.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.43,179.75c-.47,1.07-4.46.31-9.22.6s-8.66,1.35-9.23.33c-.25-.49.47-1.48,2.08-2.45a16,16,0,0,1,14.05-.71C276.81,178.32,277.63,179.24,277.43,179.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.72,183.89c-.76.87-3.48-.24-6.82-.49s-6.2.25-6.79-.75c-.26-.48.24-1.37,1.52-2.16a9.91,9.91,0,0,1,11,1C313.73,182.49,314.06,183.46,313.72,183.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.39,181.37c-1-4.48-3.1-8.86-6.71-11.7-2-1.55-4.34-2.6-6.15-4.34-3.91-3.77-4.37-9.77-6.55-14.74A22.08,22.08,0,0,0,305.21,138c-5.72-1.1-11.82.11-17.32-1.8-4.07-1.42-7.47-4.44-11.61-5.61-8.07-2.28-16.21,2.93-22.68,8.27-.54,5.87,3.8,10.21,8,14.38a20.45,20.45,0,0,0,16.11,5.8c4.55-.42,9.66-2.25,13.33.48,3.86,2.87,3.49,9,6.83,12.5,4.78,4.94,13.37,1.45,19.77,4,4.93,1.95,7.67,7.08,10.68,11.45s7.72,8.7,12.92,7.64C341.29,190.49,341.36,185.86,340.39,181.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,151.12c-3.58-1.38-10.9-4.42-12.59-7.79-3.67-7.31-10.81-12.7-18.57-13a18.63,18.63,0,0,0-18,13.19c-9.34-.75-19,4.31-24.23,12.74a27.46,27.46,0,0,0-1.76,3.3A20.39,20.39,0,0,0,203,176.52c1,3.43,2.82,7.32.84,10.29s-6.43,2.73-10,3.61A13.54,13.54,0,0,0,184,204.73c.28,2.25,1.14,4.55.48,6.72s-2.79,3.72-4.47,5.38A16.86,16.86,0,0,0,187.47,245c2.58.7,5.42.84,7.57,2.44,2.45,1.82,3.31,5.05,4.93,7.65a14.53,14.53,0,0,0,15.25,6.29,13,13,0,0,0,3.29-1.31c1.54,2.59,4.14,4.48,8.85,4.89l4.33-61.51a5.11,5.11,0,0,0,3.47,3.25c9.66,3.09,12.89-17.09,11.17-22.79,3.85-2.85,7.74-5.74,10.81-9.53s6.44-14.54,6.3-19.53C267,155.39,282.55,151.72,281,151.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,208.7c.23-6.27-7.29-8.28-13-5.63-3.13,1.45-5.7,4.71-6,11.36-.83,17.73,17.14,14.91,17.2,14.4C232.22,228.52,233.69,216,234,208.7Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.09,221.86c-.08-.06-.32.2-.86.41a3.08,3.08,0,0,1-2.31-.06c-1.84-.77-3.28-3.82-3.22-7a10.33,10.33,0,0,1,1.08-4.38,3.57,3.57,0,0,1,2.43-2.27,1.6,1.6,0,0,1,1.79.93c.21.51.08.86.17.9s.4-.28.29-1a2,2,0,0,0-.65-1.15,2.35,2.35,0,0,0-1.68-.53,4.33,4.33,0,0,0-3.36,2.6,10.45,10.45,0,0,0-1.3,4.89c-.06,3.58,1.62,7,4.15,7.87a3.29,3.29,0,0,0,2.84-.33C227,222.28,227.15,221.89,227.09,221.86Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.06,144.2c.11.2-1.83.35-3.79,2.64s-3,6.81-2.38,12.11l.06.45-.44.07a17.17,17.17,0,0,0-12.27,9,13.25,13.25,0,0,0-1.3,4.23,26,26,0,0,0,.14,4.72,33.83,33.83,0,0,1,.23,5.09,8.32,8.32,0,0,1-1.86,5.09c-2.49,3.15-6.17,4.48-9.35,5.81a30.21,30.21,0,0,0-8.68,4.65,22.2,22.2,0,0,0-7.9,14.23,23.28,23.28,0,0,0,1.36,11.13c1,2.51,1.85,3.75,1.74,3.82a4.1,4.1,0,0,1-.68-.87,18.49,18.49,0,0,1-1.51-2.77,22.55,22.55,0,0,1-1.79-11.41,22.81,22.81,0,0,1,8-15,30.37,30.37,0,0,1,9-4.9c3.18-1.33,6.65-2.67,8.82-5.45,2.2-2.51,1.63-6.09,1.4-9.3a27.35,27.35,0,0,1-.12-5,14.68,14.68,0,0,1,1.45-4.62,18,18,0,0,1,13.18-9.42l-.39.52c-.57-5.54.68-10.25,2.9-12.58a7.53,7.53,0,0,1,3-2A4.85,4.85,0,0,1,257.06,144.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.9,227.89a12.73,12.73,0,0,1,5.32-2.86l-.39-.06a10.19,10.19,0,0,1,1.1-.09,5,5,0,0,1,3.88.84h0a9.29,9.29,0,0,1,4.69,4.87,11,11,0,0,1-2.29,11.22c-2.36,2.58-6.15,4.08-9.46,3-3-1-5.1-4-5.71-7.21A10.46,10.46,0,0,1,219.9,227.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.38,308.33S80,382.45,80.69,406.38a5.93,5.93,0,0,1-.24,1.17C77.67,423.27,89.09,438,104.93,440l29.52,3.67,63.06-81.33-17.07-45.44Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,344.83s12.32-20.84,26.39-36.5c13.32-14.81,31.05-19,35-19.22,14.6-.69,76.16,3.47,115.65,5,14.67.59,29.16,9.11,38.75,20.23,21.47,24.9,59.12,69.28,66.68,82.95,10.72,19.36,3.2,63.44-4.32,69.32s-238.26-4.13-238.26-4.13Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.46,397.34a1.81,1.81,0,0,1-.48,0l-1.38-.05-1-.05c-.36,0-.76,0-1.18,0a27.77,27.77,0,0,0-2.87.15l-1.66.17c-.58.06-1.17.2-1.79.3-1.24.18-2.52.55-3.89.89a40.58,40.58,0,0,0-15.89,8.76,39.62,39.62,0,0,0-2.83,2.81c-.41.47-.84.9-1.21,1.35s-.7.9-1,1.32a27.25,27.25,0,0,0-1.65,2.34c-.24.36-.47.68-.66,1l-.48.86c-.28.47-.5.87-.69,1.19s-.26.41-.28.4a2.32,2.32,0,0,1,.18-.45c.17-.33.37-.74.61-1.24l.45-.89c.18-.32.4-.65.62-1a25.88,25.88,0,0,1,1.61-2.41c.32-.44.66-.89,1-1.35s.79-.91,1.2-1.39a40,40,0,0,1,2.83-2.88,39.76,39.76,0,0,1,16.08-8.86,39.33,39.33,0,0,1,4-.86c.62-.09,1.22-.22,1.81-.27l1.68-.14a26.73,26.73,0,0,1,2.9-.07c.43,0,.82,0,1.19,0l1,.09,1.38.15A1.53,1.53,0,0,1,389.46,397.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.57,394.2a3.1,3.1,0,0,1-.18-.69l-.43-2c-.39-1.74-1-4.25-1.91-7.32a232.07,232.07,0,0,0-8.51-23.46c-3.76-9-7.62-17-10.63-22.59-.74-1.42-1.44-2.69-2.07-3.79s-1.15-2.07-1.61-2.83l-1-1.78a3.39,3.39,0,0,1-.33-.64,3.88,3.88,0,0,1,.42.59l1.12,1.73c.49.74,1,1.69,1.69,2.78s1.38,2.35,2.14,3.76A234.9,234.9,0,0,1,175,360.51a207.11,207.11,0,0,1,8.39,23.56c.85,3.09,1.42,5.62,1.75,7.38.14.85.25,1.52.33,2A3.47,3.47,0,0,1,185.57,394.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,329.71a1.15,1.15,0,0,1,0,.25v.73c0,.69,0,1.63,0,2.82,0,2.46-.15,6-.34,10.38-.36,8.76-1.12,20.85-2.46,34.17s-3,25.31-4.41,34c-.69,4.33-1.29,7.82-1.74,10.23-.22,1.18-.4,2.1-.53,2.78l-.15.72a.64.64,0,0,1-.07.24,2.25,2.25,0,0,1,0-.25c0-.2.06-.44.1-.73.1-.68.25-1.61.43-2.79.38-2.47.92-6,1.58-10.26,1.29-8.66,2.91-20.66,4.25-34s2.15-25.38,2.62-34.13c.21-4.34.38-7.87.5-10.36.06-1.19.1-2.14.13-2.82,0-.3,0-.54.05-.73A1,1,0,0,1,338,329.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.46,286.83a6,6,0,0,0-2.82-.8L224,278.51c-2.34-.26-5-.43-6.78,1.11-2.27,1.95-1.91,5.56-.89,8.38s2.55,5.68,2,8.62L292,301.24c-.46-2.66,1.65-5,3.21-7.16S297.66,288.38,295.46,286.83Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.74,299.82a4.67,4.67,0,0,1-.8.22l-2.34.51c-1,.22-2.27.48-3.73.71s-3.11.55-5,.75l-2.89.37c-1,.12-2.07.19-3.16.29-2.17.23-4.51.31-7,.43a148.94,148.94,0,0,1-16-.38,146.53,146.53,0,0,1-15.85-2.27c-2.4-.52-4.69-1-6.8-1.58-1.06-.28-2.09-.52-3.06-.81l-2.8-.83c-1.79-.51-3.37-1.1-4.77-1.57s-2.59-.93-3.55-1.32l-2.22-.89a5.82,5.82,0,0,1-.76-.34,5.39,5.39,0,0,1,.8.24l2.25.8c1,.36,2.17.79,3.58,1.23s3,1,4.78,1.49l2.79.81c1,.27,2,.5,3.06.78,2.11.56,4.4,1,6.8,1.52a140.77,140.77,0,0,0,31.73,2.64c2.45-.1,4.78-.17,6.95-.38,1.09-.09,2.14-.15,3.14-.26l2.9-.33c1.84-.18,3.5-.47,5-.68s2.71-.43,3.73-.62l2.35-.42A4.66,4.66,0,0,1,298.74,299.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.93,372.58a36.35,36.35,0,0,0-28.41,25c3.43-1.13,6.7-4.08,9.2-6.7,6.51-6.83,14.54-11.4,23.92-12.4,6.46-.7,12.64,1,18.68,3.37,2.73,1.08,5.78,1.68,8.22,3.33l3.23.74C158.18,375,144.06,370.46,130.93,372.58Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M223.18,295c9.75,8.84,22.52,15.12,35.65,16.07s25.71-3.25,36.63-10.61C268.79,304.64,244.52,303.22,223.18,295Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M390.69,389.74c-2.15-1.36-4.88-1.33-7.41-1-15.86,1.88-31.21,12.68-32.78,30.1h0c6.68-12.92,20.42-22.39,34.91-21.14,2.44.21,5.34.5,6.9-1.39S392.83,391.11,390.69,389.74Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M86.76,473l130.06-.66s-.86,2.51,4.53,2.51l43-.3s3.18.3,3.23-2.21c0,0,100.83,1.7,125.74,2.4,1.86.05,5.16-1.08,3.61-3.45l-8.69-10.41-143.86-14-102,10.72-35-12.64h-1.16a2.94,2.94,0,0,0-2.41,1.24l-18,25A1.15,1.15,0,0,0,86.76,473Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.75 469.99 373.45 471.78 318.96 454.9 251.03 456.81 183.06 454.1 141.75 469.99",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.09,465.41l1.29-28.51s.26-15.68-18.63-20.91-42.43,1.43-64.42,2.62-21.73-.48-21.73-.48l-17.85,27.56,70.11,10.22s40.62,2.37,41.39,2.61S243.09,465.41,243.09,465.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.86,466.42l1.52-26.79S244.12,424,263,418.73s42.42,1.42,64.41,2.61c15.39.83,20.16.69,21.64.53a1.15,1.15,0,0,1,1.07.49L367,448.42,296.9,458.64s-40.62,2.38-41.4,2.61S242.86,466.42,242.86,466.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.22,470.88l30.53-25.19S185,435,206.45,438.8s33.69,11.17,36.64,26.85l-20.6,5.23A63.76,63.76,0,0,0,195.07,464c-15.52-.24-54.33,6.89-54.33,6.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.94,470.88l-21.74-5.47s1.55-24.91,36.86-29.07c0,0,10-3.24,45.41,3.41s39.07,6.42,39.07,6.42L394,472.3s-17.59,1.43-32.08-1.42-39.84-12.6-67.26-9.74S264.94,470.88,264.94,470.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.75 445.69 139.03 419.02 108.38 443.48 89.02 470.88 91.22 470.88 121.75 445.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.42,446.17l-14.08-23.66s28.05,24.38,28.29,25.07,15.28,24.72,15.28,24.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "221.35 470.88 264.82 470.88 243.09 465.41 241.95 465.65",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.09,465.41c-.15,0,0-6.23.32-13.89s.71-13.88.85-13.87,0,6.22-.33,13.89S243.23,465.42,243.09,465.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.21,441.29a2.66,2.66,0,0,1-.59.13l-1.73.3-6.42,1L121.79,446l.12-.05-4.17,3.21L97.5,464.59l-6.17,4.64-1.7,1.24a4.79,4.79,0,0,1-.61.41,3.2,3.2,0,0,1,.55-.49l1.63-1.32,6.07-4.78,20.15-15.6,4.17-3.2.06,0h.06l21.72-3.05,6.43-.86,1.74-.2A2.8,2.8,0,0,1,152.21,441.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.23,450.45s-.07-.06-.19-.2l-.53-.64c-.46-.55-1.16-1.36-2.13-2.33a37.89,37.89,0,0,0-9.36-6.8,53.61,53.61,0,0,0-16.33-5.23,135.15,135.15,0,0,0-21.07-1.4,242.71,242.71,0,0,0-38.28,2.9c-4.86.76-8.77,1.51-11.47,2.05l-3.11.63-.81.16a1,1,0,0,1-.28,0l.27-.09.8-.2c.7-.17,1.74-.43,3.09-.73,2.68-.6,6.59-1.41,11.45-2.21a229.61,229.61,0,0,1,38.34-3.06,131.38,131.38,0,0,1,21.15,1.45,53,53,0,0,1,16.42,5.38,36.41,36.41,0,0,1,9.34,7,26.74,26.74,0,0,1,2.06,2.41l.49.67A1,1,0,0,1,240.23,450.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.23,447s-.07-.06-.18-.19l-.49-.58c-.21-.27-.48-.58-.81-.94s-.7-.79-1.15-1.24a37.79,37.79,0,0,0-8.56-6.46,51.2,51.2,0,0,0-15-5.35,109.89,109.89,0,0,0-19.48-1.79,244.16,244.16,0,0,0-35.54,1.87c-4.53.58-8.17,1.15-10.69,1.57l-2.89.48-.76.12-.26,0,.25-.07.75-.17c.65-.14,1.62-.35,2.88-.58,2.5-.48,6.15-1.11,10.67-1.73a227.55,227.55,0,0,1,35.6-2,108,108,0,0,1,19.56,1.84,50.6,50.6,0,0,1,15.06,5.5,35.71,35.71,0,0,1,8.52,6.64c.44.47.82.89,1.13,1.28s.58.7.77,1l.45.62A1,1,0,0,1,240.23,447Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.23,443.49s-.07-.05-.18-.18l-.48-.58q-.31-.41-.81-.93t-1.14-1.23a37.09,37.09,0,0,0-8.46-6.42,50.47,50.47,0,0,0-14.81-5.36A107.52,107.52,0,0,0,195.06,427a243.05,243.05,0,0,0-35.21,1.76c-4.49.55-8.1,1.1-10.6,1.51l-2.87.47-.75.11a.65.65,0,0,1-.26,0l.25-.07.74-.16c.66-.13,1.62-.34,2.86-.57,2.48-.47,6.09-1.08,10.58-1.68a229.09,229.09,0,0,1,35.28-1.91,104.87,104.87,0,0,1,19.36,1.89,50.05,50.05,0,0,1,14.9,5.51,36,36,0,0,1,8.43,6.6c.44.46.8.88,1.11,1.26s.57.7.77,1l.44.61A1,1,0,0,1,240.23,443.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.23,440s-.07-.05-.18-.18l-.47-.57c-.41-.5-1-1.23-1.89-2.12a44.16,44.16,0,0,0-22.31-12.41c-5.7-1.27-12.15-1.33-18.89-1.24-13.5.08-25.71.66-34.5,1.59-4.4.44-8,.91-10.39,1.28l-2.82.42-.74.1a.69.69,0,0,1-.25,0,1.57,1.57,0,0,1,.25-.06l.72-.16c.64-.12,1.58-.31,2.8-.51,2.44-.43,6-1,10.39-1.45A338.34,338.34,0,0,1,196.49,423c6.73-.08,13.24,0,19,1.3a42.44,42.44,0,0,1,14.33,6,41,41,0,0,1,8,6.74,27.05,27.05,0,0,1,1.82,2.2l.44.6A1.31,1.31,0,0,1,240.23,440Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.23,436.53s-.06,0-.17-.18l-.47-.57c-.4-.5-1-1.24-1.82-2.16a41.84,41.84,0,0,0-7.72-6.88,33.31,33.31,0,0,0-6.27-3.37,40.72,40.72,0,0,0-7.89-2.21A90.8,90.8,0,0,0,197.12,420c-13.39.4-25.47,1.69-34.23,2.37-4.38.35-7.92.61-10.38.75l-2.82.14-.74,0h-.25l.25,0,.73-.07,2.82-.24,10.36-.92c8.75-.77,20.83-2.12,34.25-2.52A89.71,89.71,0,0,1,216,420.68a40.93,40.93,0,0,1,8,2.29,33,33,0,0,1,6.32,3.47,39.72,39.72,0,0,1,7.66,7.05c.8.94,1.38,1.7,1.75,2.23l.43.6A1.31,1.31,0,0,1,240.23,436.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.51,449.5s.05-.09.16-.24l.5-.65a26.44,26.44,0,0,1,2.11-2.38,36.41,36.41,0,0,1,9.46-6.8,53,53,0,0,1,16.52-5.08,131.17,131.17,0,0,1,21.16-1.06,229.89,229.89,0,0,1,38.29,3.76c4.84.9,8.73,1.78,11.41,2.43,1.34.32,2.37.6,3.07.78l.79.22a1.1,1.1,0,0,1,.27.09.85.85,0,0,1-.28,0l-.81-.17-3.09-.69c-2.69-.58-6.58-1.41-11.43-2.25a241.77,241.77,0,0,0-38.22-3.61,133.8,133.8,0,0,0-21.09,1,53.84,53.84,0,0,0-16.43,4.92,37.64,37.64,0,0,0-9.48,6.63c-1,.95-1.7,1.74-2.17,2.29l-.54.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.57,446l.15-.22.46-.61c.2-.27.47-.59.79-1s.7-.8,1.15-1.25a35.77,35.77,0,0,1,8.65-6.49,50.23,50.23,0,0,1,15.15-5.22,107.87,107.87,0,0,1,19.59-1.48,228.83,228.83,0,0,1,35.56,2.68c4.51.7,8.14,1.4,10.64,1.93,1.25.25,2.21.48,2.87.63l.74.18a1.26,1.26,0,0,1,.25.08.86.86,0,0,1-.26,0l-.75-.13-2.89-.53c-2.51-.47-6.14-1.11-10.66-1.77a244.1,244.1,0,0,0-35.5-2.52,109.63,109.63,0,0,0-19.5,1.43,50.89,50.89,0,0,0-15.07,5.07,37.23,37.23,0,0,0-8.68,6.31c-.46.44-.85.85-1.17,1.21s-.62.67-.83.93l-.5.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.64,442.54s0-.08.14-.22l.46-.6a11.52,11.52,0,0,1,.78-1,16.89,16.89,0,0,1,1.14-1.25,35.78,35.78,0,0,1,8.55-6.44,49.61,49.61,0,0,1,15-5.23,104.74,104.74,0,0,1,19.4-1.54,229.2,229.2,0,0,1,35.24,2.56c4.47.68,8.07,1.36,10.54,1.87,1.24.25,2.2.48,2.85.62l.73.18a.76.76,0,0,1,.25.08.86.86,0,0,1-.26,0l-.74-.12-2.87-.53c-2.48-.45-6.09-1.07-10.56-1.7a243.32,243.32,0,0,0-35.18-2.41,107.38,107.38,0,0,0-19.31,1.49,50.65,50.65,0,0,0-14.91,5.08,37.27,37.27,0,0,0-8.58,6.27c-.45.43-.84.84-1.16,1.2s-.61.66-.82.91l-.5.58C246.71,442.48,246.65,442.55,246.64,442.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.7,436.53a17.4,17.4,0,0,1,2.51-2.85,29.87,29.87,0,0,1,8.74-5.51,68.29,68.29,0,0,1,6.71-2.47,59.92,59.92,0,0,1,7.94-2.09c5.72-1.07,12.13-1,18.77-.77,13.34.42,25.32,2.07,34,3.08l10.26,1.24,2.79.33.72.1.25.05h-.25l-.73,0-2.8-.24c-2.43-.22-5.95-.59-10.28-1.07-8.68-.93-20.65-2.51-33.95-2.93-6.65-.21-13-.31-18.67.72a61.87,61.87,0,0,0-7.9,2c-2.45.76-4.7,1.55-6.7,2.4a31.07,31.07,0,0,0-8.75,5.32,16,16,0,0,0-1.16,1.12,9.8,9.8,0,0,0-.81.86l-.49.55C246.77,436.48,246.71,436.54,246.7,436.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.14,445.6v16.92l5.61-5.07,5.49,4.81.32-16.48S292.54,445.3,290.14,445.6Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.57,455.43l-.29-.05-.83-.19-3.17-.76c-2.76-.66-6.76-1.57-11.73-2.55s-10.91-2-17.53-3.1l-10.37-1.71a81.92,81.92,0,0,0-11.18-1.2,99.94,99.94,0,0,0-11.26.16,60.77,60.77,0,0,0-10.35,1.54A43,43,0,0,0,261,455.2a54.18,54.18,0,0,0-5.12,4.49c-1.44,1.41-2.61,2.69-3.56,3.74l-2.15,2.45-.56.64c-.13.14-.2.21-.21.2l.17-.24.52-.66c.46-.59,1.16-1.44,2.08-2.52s2.08-2.38,3.5-3.81a51.25,51.25,0,0,1,5.1-4.58,42.67,42.67,0,0,1,16-7.8,60,60,0,0,1,10.43-1.59,98.64,98.64,0,0,1,11.32-.17,80.89,80.89,0,0,1,11.24,1.22l10.37,1.74c6.61,1.11,12.56,2.18,17.52,3.21s9,2,11.71,2.71c1.37.35,2.43.65,3.15.86l.81.24A.87.87,0,0,1,353.57,455.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.66,467s-.09-.08-.25-.25l-.69-.76c-.31-.33-.67-.76-1.13-1.23s-1-1-1.62-1.6a50.13,50.13,0,0,0-11.87-8.25,65.87,65.87,0,0,0-20.48-6.22,102.12,102.12,0,0,0-26.28.19c-9.29,1.15-18,3-26,4.64s-15.13,3.06-21.22,3.94a133.71,133.71,0,0,1-14.49,1.36c-1.72.05-3.06.07-4,.05l-1,0-.35,0,.35,0,1,0c.9,0,2.23-.06,3.95-.14a144.08,144.08,0,0,0,14.44-1.53c6.07-.91,13.24-2.36,21.18-4s16.7-3.54,26-4.69a101.7,101.7,0,0,1,26.41-.15,65.64,65.64,0,0,1,20.59,6.37A49.33,49.33,0,0,1,232.11,463l1.6,1.64c.45.49.79.93,1.09,1.27l.66.79A1.19,1.19,0,0,1,235.66,467Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.66,470.51s-.09-.08-.25-.25l-.69-.76c-.31-.33-.67-.76-1.13-1.23l-1.62-1.6a50.42,50.42,0,0,0-11.87-8.25,65.87,65.87,0,0,0-20.48-6.22,102.12,102.12,0,0,0-26.28.19c-9.29,1.15-18,3-26,4.64s-15.13,3.07-21.22,3.94a134.2,134.2,0,0,1-14.49,1.37c-1.72,0-3.06.06-4,0l-1,0-.35,0,.35,0,1,0c.9,0,2.23-.06,3.95-.14a143.51,143.51,0,0,0,14.44-1.52c6.07-.92,13.24-2.36,21.18-4.05s16.7-3.53,26-4.69a101.7,101.7,0,0,1,26.41-.15,65.9,65.9,0,0,1,20.59,6.37,49.33,49.33,0,0,1,11.84,8.43l1.6,1.64c.45.49.79.93,1.09,1.27l.66.8C235.6,470.41,235.67,470.5,235.66,470.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.38,467.53a4.09,4.09,0,0,1-.55-.41c-.36-.27-.85-.72-1.55-1.22a43.77,43.77,0,0,0-6.09-3.87,50.41,50.41,0,0,0-9.94-3.94,65.26,65.26,0,0,0-12.91-2.21,119.68,119.68,0,0,0-23.81,1.19l-7.18,1-2,.27a3.15,3.15,0,0,1-.68,0,4.05,4.05,0,0,1,.67-.16l1.94-.36c1.68-.31,4.12-.73,7.16-1.18a113.24,113.24,0,0,1,23.9-1.34,63.16,63.16,0,0,1,13,2.27,49.36,49.36,0,0,1,10,4.07,39.53,39.53,0,0,1,6,4c.68.53,1.15,1,1.49,1.3A2.94,2.94,0,0,1,225.38,467.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.88,396.76l35.32-7.63s13.24-2.67,15.8-1.26,17.31,13.21,18.58,14.31,15.37,18,15.37,18-.32,5.35-8.06,3.2c-4-1.1-20.92-15.9-20.92-15.9L239,404.36s6.17,9.56,6.05,12.7-4.05,9.41-5.4,10.27-8.11-.32-8.11-.32-4.8,5.18-8.57,1.1c0,0-6.43,6.69-11.65,2.81l-2.8-5.49-2.67-2.07s-.41,3.78-3,4.2-31.64-5.84-31.64-5.84l10-27.33Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.43,406.43a3.26,3.26,0,0,1,.81.54c.5.39,1.21,1,2,1.73a38.91,38.91,0,0,1,5.82,6.65,11.37,11.37,0,0,1,1.14,2.29,4.32,4.32,0,0,1,.29,2.4,15.53,15.53,0,0,1-1.06,3.86,12.26,12.26,0,0,1-1.23,2.39,2.39,2.39,0,0,1-.67.72s.2-.29.5-.83a14.86,14.86,0,0,0,1.06-2.42,16.76,16.76,0,0,0,.93-3.77,5.67,5.67,0,0,0,0-1.09,6.41,6.41,0,0,0-.3-1.09,11.8,11.8,0,0,0-1.11-2.18A46.41,46.41,0,0,0,227,409C225.44,407.39,224.38,406.49,224.43,406.43Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.2,409.57a3.41,3.41,0,0,1,1.09-.35,9.1,9.1,0,0,1,3.13-.13,13.33,13.33,0,0,1,8.71,5.17,17.28,17.28,0,0,1,2.45,5.13,31.75,31.75,0,0,1,1,4.5c.2,1.29.31,2.35.37,3.08a4.75,4.75,0,0,1,0,1.14c-.09,0-.27-1.6-.76-4.16a39.84,39.84,0,0,0-1.12-4.42,17.44,17.44,0,0,0-2.41-5,13.73,13.73,0,0,0-4.12-3.6,12.72,12.72,0,0,0-4.23-1.52A13.82,13.82,0,0,0,206.2,409.57Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.12,396.05s.2-.1.6-.19a2.88,2.88,0,0,1,.75-.05,4,4,0,0,1,1,.11,11.81,11.81,0,0,1,5,2.7,23.85,23.85,0,0,1,3.86,4.13,7.2,7.2,0,0,1,1.22,2A18.34,18.34,0,0,1,238,403a34,34,0,0,0-3.91-4,13,13,0,0,0-4.73-2.74A11.25,11.25,0,0,0,227.12,396.05Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.68,390.69,163,383.8l-32.55,1.67-16.22,21.88-6.51,31.51s59.61-13.09,61.5-13.27,4.93-3.24,4.93-3.24l6.36,1.33,8.15-27.3Z",
    style: {
      fill: "#AE7EDE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.33,394.92l-.24-.06-.68-.25-2.63-1-9.61-3.71-14.23-5.56-8.39-3.31a69.35,69.35,0,0,0-9.12-3.13,27.19,27.19,0,0,0-9.53-.73,33.35,33.35,0,0,0-8.67,2.1,51.77,51.77,0,0,0-13.1,7.64c-3.43,2.66-6,5-7.85,6.65l-2.08,1.87-.55.47c-.13.11-.2.16-.2.15a.87.87,0,0,1,.16-.18l.52-.52,2-1.94c1.77-1.66,4.34-4.08,7.75-6.79a51.22,51.22,0,0,1,13.15-7.8,33.77,33.77,0,0,1,8.8-2.16,27.89,27.89,0,0,1,9.7.73,68,68,0,0,1,9.19,3.17l8.38,3.34,14.19,5.66,9.55,3.86,2.59,1.08.66.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.44,442.85c-.71-1.19-1-2.88.73-4.91l4.76-2.12a14,14,0,0,1,2.33-4.06c1.22-1.11,3-2.53,3-2.53s2.63-3.64,5.16-5.16,8.71-3.14,10.84-5,8.81-7.7,13.47-5.47,8,10.06,11.64,11.71,5,7.12,6.38,9.35,2.94,3.85,3.14,5.57,4.15,5.17,4.86,9.82.31,6.28-1.82,8-6.28,5.17-10.43,5.78c-2.33.34-5.52.55-7.87.67a4.7,4.7,0,0,1-4.5-2.7l-.29-.61s-10.63,5.37-15.69,4.66-3-5.06-3-5.06-5.17,5-8.41,4.05-5-.81-5.26-3.65,2.12-6.08,2.12-6.08-4.86.11-5.26-3.13a13.6,13.6,0,0,1,1.31-6.69l-3.9-.44A4.39,4.39,0,0,1,336.44,442.85Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.65,421.15a6.19,6.19,0,0,1-.48,1.15,10.84,10.84,0,0,1-.7,1.29,18.12,18.12,0,0,1-1.05,1.63,33.53,33.53,0,0,1-3.25,3.87c-1.32,1.36-2.84,2.79-4.46,4.26s-3.12,2.89-4.44,4.24a34.61,34.61,0,0,0-3.21,3.81c-1.66,2.32-2.3,4-2.41,3.93a6.34,6.34,0,0,1,.45-1.16,8.35,8.35,0,0,1,.65-1.32,17,17,0,0,1,1-1.66,31.55,31.55,0,0,1,3.18-3.93c1.3-1.38,2.82-2.82,4.43-4.29s3.14-2.88,4.47-4.21a37.34,37.34,0,0,0,3.29-3.76C362.83,422.73,363.55,421.09,363.65,421.15Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.84,425.54a1.64,1.64,0,0,1-.13.41c-.1.27-.25.65-.47,1.14a37.49,37.49,0,0,1-2.09,4,37.71,37.71,0,0,1-10,11.06c-2.33,1.78-4.65,3.32-6.72,4.75s-3.91,2.77-5.37,4a40.91,40.91,0,0,0-3.32,3,11.8,11.8,0,0,1-1.15,1.19,8.78,8.78,0,0,1,1-1.33,32.61,32.61,0,0,1,3.23-3.19c1.45-1.25,3.27-2.63,5.33-4.09s4.37-3,6.68-4.77a41.46,41.46,0,0,0,6-5.51,42.75,42.75,0,0,0,4-5.33c1-1.61,1.73-3,2.22-3.92A10.8,10.8,0,0,1,376.84,425.54Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.47,426.8c.09.11-.67.95-1.72,1.87s-2,1.58-2.06,1.47.67-.94,1.72-1.86A6.5,6.5,0,0,1,378.47,426.8Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.77,439a5.78,5.78,0,0,1-.41,1.29,16.17,16.17,0,0,1-1.74,3.26,30.42,30.42,0,0,1-8.91,8.23c-4,2.56-7.73,4.66-10.34,6.32-1.31.82-2.36,1.51-3.08,2a8.13,8.13,0,0,1-1.14.72,6,6,0,0,1,1-.88c.69-.54,1.71-1.27,3-2.14,2.57-1.75,6.29-3.9,10.26-6.45a32.19,32.19,0,0,0,8.89-8A30.66,30.66,0,0,0,384.77,439Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.12,445.59a3.47,3.47,0,0,1-.41.85c-.28.53-.74,1.27-1.34,2.16a39.34,39.34,0,0,1-5.49,6.36,40.35,40.35,0,0,1-3.57,2.94,30.63,30.63,0,0,1-3.22,2c-.47.26-.91.46-1.3.64s-.73.32-1,.42a2.89,2.89,0,0,1-.9.27c0-.08,1.2-.58,3-1.66a34.44,34.44,0,0,0,3.11-2.06c1.12-.85,2.32-1.83,3.51-2.93a49,49,0,0,0,5.54-6.2C394.34,446.68,395,445.55,395.12,445.59Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.11,434.14a31.21,31.21,0,0,1-4.41,2,37,37,0,0,1-4.53,1.76c-.08-.16,1.85-1.2,4.33-2.24S346.05,434,346.11,434.14Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,415.57a42,42,0,0,1,5.2.16,79.77,79.77,0,0,1-10.41,0A42.13,42.13,0,0,1,349,415.57Z",
    style: {
      fill: "#AE7EDE"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartLearning);
export default __webpack_public_path__ + "static/media/StartLearning.fceff11f15eec1e1b724bff694659046.svg";
export { ForwardRef as ReactComponent };